import React from 'react';
// import { SvgIcon } from '@material-ui/core';
import Logo from '../../assets/images/interswitch_logo.svg';
import energyLogo from  '../../assets/images/energyLogo.svg';

export const LogoIcon = ({ classname }) => <img className={classname} src={Logo} alt="Interswitch Logo"/>

export const EnergyLogoIcon = ({classname }) => <img className={classname} src={energyLogo} alt="Interswitch Energy" />